import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui";
import { TaskPlanning } from "./TaskPlanning";
import { editTabs, extraTabs, qualityCheckTab, safetyCheckTab, tabs } from "./const";
import useAddEdit from "./useAddEdit";
import AddEditTaskContext from "./AddEditTaskContext";
import { ActualTask } from "./ActualTask";
import { Notes } from "./Notes";
import { Attachments } from "./Attachments";
import { SafetyCompliance } from "./SafetyCompliance";
import { QualityCheck } from "./QualityCheck";
import { cn } from "@/lib/utils";

const AddEdit = ({isTaskExist, taskList, fromPreview}: {isTaskExist: boolean, taskList: any, fromPreview?: boolean}) => {
  const { activeTab, onChangeTab, taskData } = useAddEdit();

  return (
    <AddEditTaskContext.Provider value={{ isTaskExist: isTaskExist, taskList: taskList }}>
        <Tabs value={activeTab} defaultValue="task-planning">
          <TabsList className="bg-transparent px-4 w-full">
            {[...tabs, ...taskData ? editTabs : extraTabs, ...taskData?.requiresSafetyCheck ? safetyCheckTab : [], ...taskData?.requiresQualityCheck ? qualityCheckTab : []]?.map((data: any, index: number) => (
              <TabsTrigger
                key={data?.value}
                value={data?.value}
                disabled={index > 0 && !taskData}
                onClick={() => onChangeTab(data.value)}
                className="font-[12px]"
              >
                {data?.title}
              </TabsTrigger>
            ))}
          </TabsList>
          <div className="h-[0.5px] w-[100%] bg-gray-200 "/>
          <div className={cn("no-scrollbar", fromPreview ? "max-h-[100vh] overflow-y-scroll pb-30" : "max-h-[calc(100vh-300px)] overflow-y-scroll")}>
            <TabsContent value="task-planning">
              <TaskPlanning />
            </TabsContent>
            <TabsContent value="actual-task">
              <ActualTask />
            </TabsContent>
            <TabsContent value="notes">
              <Notes />
            </TabsContent>
            <TabsContent value="attachments">
              <Attachments />
            </TabsContent>
            <TabsContent value="safety-form">
              <SafetyCompliance />
            </TabsContent>
            <TabsContent value="quality-check">
              <QualityCheck />
            </TabsContent>
          </div>
        </Tabs>
    </AddEditTaskContext.Provider>
  );
};

export default AddEdit;
